import type { FaireProductEntity } from "../../entity_types/product";

export const p_989kqeb6mb: FaireProductEntity = {
  token: "p_989kqeb6mb",
  type: "product",
  name: "Owner Of The World's Cutest Dog Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/ee8859f78942808a2f1ef3ed8a7afea81da549e4ecdcec3236f02af979f59669.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/31d722ce0cfa85dd80636f44d7d463819f7a4b6d753bab67d0d4b33250966fd4.jpeg",
    "https://cdn.faire.com/fastly/dfbdbf89d1e7ec6e496c8cecc715e8d7fc8bd462c855f7fe53952feff14887f4.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/ac79e1a99bcf127537a5e7f1f24e02985d6e28fc3712b18d2bae501ad8dc0ca8.jpeg",
    "https://cdn.faire.com/fastly/00b314fc84850d65d37a31e41a245cc48e36b4ade326231ea0d9bb7049532bed.jpeg",
    "https://cdn.faire.com/fastly/693333e84757cbaab97a3ac20a686e92b75d5022bbb160e0893ede565497545c.jpeg"
  ],
  priceDollars: 6.75,
  description: "What’s soft, fuzzy, warm, makes you feel like life is worth living, and looks amazing while doing it?\n\nThese socks!\n\nAnd also probably your dog 🐶\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:28:08.389Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
